import SectionMessage from '@atlaskit/section-message';
import * as React from 'react';
export default {
  SectionMessage,
  React
};